<div class="option" *ngIf="option">
	<input type="checkbox" [(ngModel)]="option.included" 
	    (change)="changeState()" [disabled]="option.excluded || option.mutuallyExcluded || option.quantityExcluded || option.required" />
	<span class="text-wrap" [ngClass]="{ disabled: option.excluded || option.mutuallyExcluded || option.quantityExcluded }">
	   <span class="description">({{ option.sku }}) {{ option.alias || option.description }}</span>
	  <!--  <span class="msrp">{{ option.msrp | currency }}</span> -->
	</span>
	&nbsp;
	
	<!-- <span *ngIf="option.included">
	   Quantity: 
	   <span class="minus" *ngIf="option.quantity > 1" (click)="decrement()">-</span>
	   <span class="quantity">{{ option.quantity }}</span>
	   <span class="plus" *ngIf="option.quantity < option.maxQuantity" (click)="increment()">+</span>
	</span> -->
	
	<div appTooltip class="info" *ngIf="option.requiredBy || option.required" [position]="getTooltipPosition()" [width]="200">
	    <div class="trigger"></div>
	    <div class="tooltip">
	        <span class="bold">Required by:</span>
	        <ul>
	            <li *ngFor="let item of option.requiredByItems">{{ item }}</li>
	        </ul>
	    </div>
	</div>
	
	<div appTooltip class="recommended" *ngIf="option.recommended" [position]="getTooltipPosition()" [width]="200">
	    <div class="trigger"></div>
	    <div class="tooltip">
	        <span class="bold">Recommended for use with:</span>
	        <ul>
	            <li *ngFor="let item of option.recommendedByItems">{{ item }}</li>
	        </ul>
	    </div>
	</div>
	
	<div appTooltip class="recommended" *ngIf="option.endorsed" [position]="getTooltipPosition()" [width]="200">
	    <div class="trigger"></div>
	    <div class="tooltip">
	        <span>{{ option.endorsedReason ? option.endorsedReason : 'This item is recommended' }}</span>
	    </div>
	</div>
	
	<div appTooltip class="info" *ngIf="option.excluded || option.mutuallyExcluded" [position]="getTooltipPosition()" [width]="200">
	    <div class="trigger"></div>
	    <div class="tooltip">
	        <span class="bold">Cannot be used with:</span>
	        <ul>
	            <li *ngFor="let item of option.excludedByItems">{{ item }}</li>
	        </ul>
	    </div>
	</div>
	
	<div appTooltip class="info" *ngIf="option.quantityExcluded" [position]="getTooltipPosition()" [width]="200"> 
        <div class="trigger"></div>
        <div class="tooltip">
            <span>Maximum quantity reached</span>
        </div>
    </div>
</div>
